import { render } from "./ListTrialBalances.vue?vue&type=template&id=4bdb37b4&scoped=true"
import script from "./ListTrialBalances.vue?vue&type=script&lang=js"
export * from "./ListTrialBalances.vue?vue&type=script&lang=js"

import "./ListTrialBalances.vue?vue&type=style&index=0&id=4bdb37b4&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdb37b4"]])

export default __exports__